module.exports = __webpack_public_path__ + "static/media/Shadbrook-Bylaws.296ff990.pdf";